// resources/js/admin/components/shared/pages/PageRow.tsx

import { Page } from "../../../types/features/Page";
import TableRow from "../../ui/TableRow";
import { FileText } from "lucide-react";

interface PageRowProps {
    page: Page;
    onAction: (page: Page) => void;
    onSelect?: (page: Page, isSelected: boolean) => void;
    isSelected?: boolean;
    selectable?: boolean;
}

export default function PageRow({
    page,
    onAction,
    onSelect,
    isSelected = false,
    selectable = false,
}: PageRowProps) {
    const getStatusBadge = () => {
        const statusMap: Record<string, { label: string; className: string }> = {
            draft: { label: "Brouillon", className: "bg-gray-100 text-gray-700" },
            review: { label: "En relecture", className: "bg-yellow-100 text-yellow-700" },
            published: { label: "Publié", className: "bg-green-100 text-green-700" },
            archived: { label: "Archivé", className: "bg-red-100 text-red-700" },
        };
        return statusMap[page.status] || statusMap.draft;
    };

    const statusBadge = getStatusBadge();

    return (
        <TableRow
            item={page}
            onAction={onAction}
            onSelect={onSelect}
            isSelected={isSelected}
            selectable={selectable}
            actionable={true}
        >
            <td className="py-3 px-4">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center">
                        <FileText className="w-5 h-5 text-blue-600" />
                    </div>
                    <div>
                        <span className="font-medium text-gray-800 block">
                            {page.name || page.slug_key}
                        </span>
                        <span className="text-xs text-gray-500">/{page.slug_key}</span>
                    </div>
                </div>
            </td>


            <td className="hidden md:table-cell py-3 px-4">
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusBadge.className}`}>
                    {statusBadge.label}
                </span>
            </td>

            <td className="hidden lg:table-cell py-3 px-4">
                <span className="text-xs text-gray-500">v{page.version}</span>
            </td>

            <td className="hidden xl:table-cell py-3 px-4">
                <span className="text-gray-500 text-sm">
                    {new Date(page.updated_at).toLocaleDateString("fr-FR")}
                </span>
            </td>
        </TableRow>
    );
}